export function exhaustiveCheck(value: never): void {}
